import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@core/services';

@Injectable()
export class AdminProhibitedGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authService.user?.isAdmin) {
            this.router.navigate(['/invoice']);
            return false;
        }
        return true;
    }
}